import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { GetRoles, UpdateRole } from "../../../utils";
import { isAuthenticated } from "../../../utils/auth";
import Table from "../../table/Table";
import RolesWrapper from "./RolesWrapper";
import { CreateBtn } from "../../../components";
import { CommonApiDataContext } from "../../../context/CommonApiDataContext";
import ModalDialog from "../../../components/modal/modalDialog";
import { moduleConfig } from "../../../config";

const Roles = () => {
    const [data, setData] = useState([]);
    const [currPage, setCurrPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(20);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState({ searchText: "", searchBy: moduleConfig.roles?.searchableItems[0]?.value });
    const history = useHistory();
    const { handleOpenSnackbar } = useContext(CommonApiDataContext);

    const getAccessToken = () => {
        // Retrieve the access token from local storage
        return localStorage.getItem("accessToken");
    };

    // Check if the user is authenticated on component mount
    useEffect(() => {
        document.title = "Gateway Admin | Roles";
        if (!isAuthenticated()) {
            // User is not authenticated, redirect to the login page
            history.push("/login");
        }
    }, [history]);

    useEffect(() => {
        const accessToken = getAccessToken();

        const fetchGradeData = async () => {
            setLoading(true);
            try {
                const data = await GetRoles(currPage, limit);
                setData(data?.roles?.reverse());
                setCurrPage(data?.currentPage);
                setTotalPages(data?.totalPages);
                setLoading(false);
            } catch (error) {
                handleOpenSnackbar(true, error?.response?.data?.detail, "error");
                setLoading(false);
            }
        };
        fetchGradeData(accessToken);
    }, [currPage, limit]);

    const closeModal = () => setOpen(false);

    const onUpdateRole = async (updatedData) => {
        const accessToken = getAccessToken();
        try {
            const res = await UpdateRole(accessToken, updatedData);
            const UUD = data.map((e) => {
                if (e.role_id === updatedData.role_id) {
                    return res;
                }
                return e;
            });
            setData(UUD);
            handleOpenSnackbar(true, "Role has been successfully Updated", "success");
        } catch (error) {
            handleOpenSnackbar(true, error?.response?.data?.detail, "error");
        }
    };

    const handleToggle = async (item) => {
        let chngIsAtvTo = null;

        const updatedList = data.map((e) => {
            if (e?.tenant_id === item?.tenant_id) {
                const isActive = item?.active;
                chngIsAtvTo = !isActive;
                return {
                    ...e,
                    active: !isActive,
                };
            }
            return e;
        });

        // payload for activate or deactivate the Tenants
        const updateStatusPayload = {
            role_id: item?.role_id,
            active: chngIsAtvTo,
        };

        await onUpdateRole(updateStatusPayload);
    };

    return (
        <section className="section">
            <div className="title-createbtn-box">
                <h1 className="title">Roles</h1>
                <CreateBtn setOpen={setOpen} />
                <ModalDialog open={open} onClose={() => setOpen(false)}>
                    <RolesWrapper
                        ModalTitle="Create Role"
                        closeModal={closeModal}
                        dta={data}
                        setData={setData}
                        type="default"
                    />
                </ModalDialog>
            </div>
            <Table
                navigationId={4}
                pageTitle="Roles"
                data={data}
                setCurrPage={setCurrPage}
                setTotalPages={setTotalPages}
                currPage={currPage}
                totalPages={totalPages}
                limit={limit}
                setLimit={setLimit}
                loading={loading}
                onToggle={handleToggle}
                updateItem={onUpdateRole}
                EditForm={RolesWrapper}
                setData={setData}
                setSearch={setSearch}
                search={search}
            />
        </section>
    );
};

export default Roles;
